import { DonutChart } from "@/components/charts";
import { formatCurrency } from "@app/utils/currency";
import type { SpendDimension, SpendSegment } from "./dashboard-types";
import { DashboardCard, DASHBOARD_SUMMARY_CARD_CLASS } from "./dashboard-card";
import { DashboardCardSelect } from "./dashboard-card-select";

const SPEND_DIMENSION_OPTIONS = [
    { id: "category", label: "Category" },
    { id: "user", label: "User" },
    { id: "department", label: "Department" },
] as const;

export interface SpendCardProps {
    segments: SpendSegment[];
    dimension: SpendDimension;
    onDimensionChange: (dimension: SpendDimension) => void;
}

export function SpendCard({ segments, dimension, onDimensionChange }: SpendCardProps) {
    return (
        <DashboardCard
            title="Spend"
            className={DASHBOARD_SUMMARY_CARD_CLASS}
            filter={
                <DashboardCardSelect
                    label="Spend grouping"
                    selectedKey={dimension}
                    options={[...SPEND_DIMENSION_OPTIONS]}
                    onSelectionChange={(key) => onDimensionChange(key as SpendDimension)}
                />
            }
        >
            <div className="flex flex-1 flex-col items-center gap-5">
                <DonutChart
                    className="mx-auto aspect-square w-full max-w-[200px]"
                    ariaLabel="Spend breakdown chart"
                    segments={segments.map((segment) => ({
                        label: segment.label,
                        value: segment.amount,
                        color: segment.color,
                    }))}
                />

                <ul className="w-full space-y-2.5">
                    {segments.map((segment) => (
                        <li key={segment.id} className="flex items-center justify-between gap-3 text-sm">
                            <span className="flex min-w-0 items-center gap-2.5 text-gray-700">
                                <span className="size-3 shrink-0 rounded-sm" style={{ backgroundColor: segment.color }} aria-hidden />
                                <span className="truncate">{segment.label}</span>
                            </span>
                            <span className="shrink-0 font-medium text-gray-900">{formatCurrency(segment.amount, "USD", "")}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </DashboardCard>
    );
}
